import {
  TEAM_LIST_LOADING,
  GET_TEAM_LIST,
  GET_TEAM_LIST_ERROR,
  GET_TEAM_BY_ID_LOADING,
  GET_TEAM_BY_ID_SUCCESS,
  GET_TEAM_BY_ID_ERROR,
  DELETEING_TEAM,
  DELETE_TEAM,
  DELETE_TEAM_ERROR,
  DELETED_TEAM_LIST_LOADING,
  GET_DELETED_TEAM_LIST,
  GET_DELETED_TEAM_LIST_ERROR,
  PERMA_DELETEING_TEAM,
  PERMA_DELETE_TEAM,
  PERMA_DELETE_TEAM_ERROR,
  RESTORE_TEAM_LIST_LOADING,
  RESTORE_TEAM_LIST,
  RESTORE_TEAM_LIST_ERROR
} from "./types";
import axios from "axios";
import { BASE_URL } from "../urls";
import { message } from "antd";

export const getList = (tokenData) => async (dispatch) => {
  dispatch({
    type: TEAM_LIST_LOADING,
  });
  await axios
    .get(`${BASE_URL}api/v1/admin/team/member/active`, {
      headers: {
        'Authorization': `${tokenData.token_type} ${tokenData.access_token}`
      }
    })
    .then(function (response) {
      dispatch({
        type: GET_TEAM_LIST,
        payload: response,
      });
    })
    .catch(function (error) {
      dispatch({
        type: GET_TEAM_LIST_ERROR,
        payload: error.response,
      });
    });
};

export const getEntityById = (tokenData, id) => async (dispatch) => {
  dispatch({
    type: GET_TEAM_BY_ID_LOADING,
  });
  await axios
    .get(`${BASE_URL}api/v1/admin/team/member/active/${id}`, {
      headers: {
        'Authorization': `${tokenData.token_type} ${tokenData.access_token}`
      }
    })
    .then(function (response) {
       dispatch({
        type: GET_TEAM_BY_ID_SUCCESS,
        payload: response,
      });
    })
    .catch(function (error) {
      dispatch({
        type: GET_TEAM_BY_ID_ERROR,
        payload: error.response,
      });
    });
};

export const getDeletedList = (tokenData) => async (dispatch) => {
  dispatch({
    type: DELETED_TEAM_LIST_LOADING,
  });
  await axios
    .get(`${BASE_URL}api/v1/admin/team/member/deleted`, {
      headers: {
        'Authorization': `${tokenData.token_type} ${tokenData.access_token}`
      }
    })
    .then(function (response) {
      dispatch({
        type: GET_DELETED_TEAM_LIST,
        payload: response,
      });
    })
    .catch(function (error) {
      dispatch({
        type: GET_DELETED_TEAM_LIST_ERROR,
        payload: error.response,
      });
    });
};

export const deleteEntityById = (idList) => async (dispatch) => {
  dispatch({
    type: DELETEING_TEAM,
  });
  let bulk = {bulk: idList}
  await axios
    .post(`${BASE_URL}api/v1/admin/team/member/bulk/delete`, bulk, {
      headers: {
        'Authorization': `${localStorage.token_type} ${localStorage.access_token}`
      }
    })
    .then(function (response) {
      dispatch({
        type: DELETE_TEAM,
        payload: response,
      })      
      message.success(response.data.message);
    })
    .catch(function (error) {
      dispatch({
        type: DELETE_TEAM_ERROR,
        payload: error.response,
      })      
      message.error(error.response.data.message);
    });
};

export const permanentDeleteEntity = (idList) => async (dispatch) => {
  dispatch({
    type: PERMA_DELETEING_TEAM,
  });
  let bulk = {bulk: idList}
  await axios
    .post(`${BASE_URL}api/v1/admin/team/member/bulk/perma-delete`, bulk, {
      headers: {
        'Authorization': `${localStorage.token_type} ${localStorage.access_token}`
      }
    })
    .then(function (response) {
      dispatch({
        type: PERMA_DELETE_TEAM,
        payload: response,
      })
      
      message.success(response.data.message);
    })
    .catch(function (error) {
      dispatch({
        type: PERMA_DELETE_TEAM_ERROR,
        payload: error.response,
      })
      
      message.error(error.response.data.message);
    });
};

export const restoretDeleteEntity = (idList) => async (dispatch) => {
  dispatch({
    type: RESTORE_TEAM_LIST_LOADING,
  });
  let bulk = {bulk: idList}
  await axios
    .post(`${BASE_URL}api/v1/admin/team/member/bulk/restore`, bulk, {
      headers: {
        'Authorization': `${localStorage.token_type} ${localStorage.access_token}`
      }
    })
    .then(function (response) {
      dispatch({
        type: RESTORE_TEAM_LIST,
        payload: response,
      })      
      message.success(response.data.message);
    })
    .catch(function (error) {
      dispatch({
        type: RESTORE_TEAM_LIST_ERROR,
        payload: error.response,
      })      
      message.error(error.response.data.message);
    });
};